module.exports = __webpack_public_path__ + "img/opensea.46174bfd.png";